import { render } from "./CardStatus.vue?vue&type=template&id=0ddbd59a&ts=true"
import script from "./CardStatus.vue?vue&type=script&lang=ts"
export * from "./CardStatus.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Route\\Vue\\dashboard-tahsel-metronic\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__